/**
 * file : AllTournament/Tap/Ranking.jsx
 * 설명 : 랭킹
 */

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { SSE } from 'components/Common/ApiCall';

export default function Ranking() {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setData] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(5)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 5
    setListCount(count);
  }
  // SSE 통신
  useEffect(() => {
    const { start, stop } = SSE();

    start('/all-ranking',
    (result) => {
      setData(result);
    }, (err) => {
      console.error('SSE AllRanking 통신 중 오류:', err);
    })

    return () => {
      stop();
    };
  }, []);
  
  return (
    <div className="zeus-tab-item">
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>토너먼트 명</th>
              <th>플레이어</th>
              <th>누적당첨금액</th>
              <th>순위</th>
            </tr>
          </thead>
          <tbody>
            {
              !Fnc.Empty(datas) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index}>
                  <td>{data.tournament_name}</td>
                  <td>
                    {data.user_id}
                    {data.user_idx === info.idx && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -910 960 960" width="25px" fill="#0D7EE7"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" /></svg>}
                  </td>
                  <td className="align_r"><span className="won"></span>{data.amount.toLocaleString()}</td>
                  <td className="align_r">{`${data.rank}위`}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </div>
  )
}